import React from 'react';
import './../../ff001-starstruck-lines/ff001-starstruck.css';
import { isNumeric, wrap, range, getSymbolCountsFromWindow, generateWindowFromReelStrips } from './../../../helpers';
import { Reel } from './../../reel/reel';
import { ICoin } from './../../ff001-starstruck-lines/interfaces';
import * as coinHelpers from './../../ff001-starstruck-lines/coin-spins/helpers';
import CoinSpins from './../../ff001-starstruck-lines/coin-spins/coin-spins';
import { IScenarioDB } from '..';
import { BigWin } from './../../big-win/big-win';

function Spin(props: { config: any; scenario: IScenarioDB, index: number; isLastSpin: boolean; onScenarioUpdated: (scenario: IScenarioDB, i: number) => unknown }) {
  const [config] = React.useState(props.config);
  const [window, setWindow] = React.useState<string[][]>([]); 
  const [useVortexReels, setUseVortexReels] = React.useState(false);
  const [editVortexCoins, setEditVortexCoins] = React.useState(false);
  const [selectedCoinType, setSelectedCoinType] = React.useState<'price' | 'mini' | 'minor' | 'major'>('price');
  const [selectedMultiplier, setSelectedMultiplier] = React.useState<number>(50);
  
  const updateScenario = (params: Partial<IScenarioDB>) => {
    const newScenario = {...props.scenario, ...params};
    props.onScenarioUpdated(newScenario, props.index);
  }
  
  const initVortexCoinsIfNeeded = () => {
    if (!props.scenario.vortexCoins) {
      const vortexCoins = config.reelsSetup.map((size: number) => Array(size).fill(null));
      updateScenario({ vortexCoins });
      return vortexCoins;
    }
    return props.scenario.vortexCoins;
  }
  
  const toggleCoinAtPosition = (ri: number, ci: number) => {
    if (!useVortexReels || !editVortexCoins) return;
    
    const vortexCoins = initVortexCoinsIfNeeded();
    const newVortexCoins = vortexCoins.map((reel: any, reelIdx: number) => 
      reel.map((coin: ICoin | null, colIdx: number) => {
        if (reelIdx === ri && colIdx === ci) {
          // Toggle: if coin exists, remove it; otherwise add new coin
          if (coin) {
            return null;
          } else {
            const newCoin: ICoin = {
              enabled: true,
              startWindowIndex: 0,
              coinType: selectedCoinType,
              multiplier: selectedCoinType === 'price' ? selectedMultiplier : 
                          selectedCoinType === 'mini' ? config.jackpotTotalBetMultipliers?.mini ?? 10 :
                          selectedCoinType === 'minor' ? config.jackpotTotalBetMultipliers?.minor ?? 50 :
                          0, // major/grand handled by backend
              totalWinInCredits: 0, // Will be calculated server-side
              history: [],
            };
            return newCoin;
          }
        }
        return coin;
      })
    );
    updateScenario({ vortexCoins: newVortexCoins });
  }
  
  const hasCoinAtPosition = (ri: number, ci: number): boolean => {
    return !!(props.scenario.vortexCoins?.[ri]?.[ci]);
  }
  
  const setReelIndex = (params: {reelIndex: number, dir?: 1 | -1, forcedIndex?: number }) => {
    const { reelIndex, dir, forcedIndex } = params;
    const reelIndexes = props.scenario.reelIndexes;
    const reelStrips = useVortexReels ? config.vortexReels : (props.index > 0 ? config.freeSpinsReels : config.baseSpinsReels);
    const reels = reelStrips[reelIndex];
    const n = (typeof forcedIndex === 'number') ? forcedIndex : reelIndexes[reelIndex] + (1 * dir!);
    const c = wrap(n, reels);
    const w = c < 0 ? (reels.length + c) : c;
    updateScenario({reelIndexes: reelIndexes.map((x, i) => i === reelIndex ? w : x) });
  }
  const onCoinSpinsWindowsUpdated = (coinSpins: (ICoin | null)[][][]) => {
    updateScenario({otherData: { coinSpins, coinSpinIndex: 0}});
  }
  React.useEffect(() => {
    const t = setTimeout(() => {
      const w = getSymbolCountsFromWindow(window);
      const coin = w['coin'] ?? 0;
      // const triggerCount = config.coinFeature.coinTrigger ?? 100000; if (triggerCount===100000) { throw new Error('CoinTrigger isnt found the config')}
      // if (coin >= triggerCount ) {
      //   if (coinHelpers.coinWindowsMatch(window, props.scenario?.otherData?.coinSpins?.[0])) { return; }
      //   console.log(`creating new coin spins game coins: ${coin} spins: ${config.coinFeature.coinTriggerSpinCount}`);
      //   const coins = coinHelpers.getCoins(props.config);
      //   const firstWindow = window.map((reel, ri) => reel.map((col, ci) => col === 'coin' ? {...coins[0].coin, startWindowIndex: 0} : null));
      //   const cs = range(4).map((i) => {
      //     if (i === 0) { return firstWindow };
      //     return coinHelpers.copyWindow(firstWindow);
      //   });
      //   onCoinSpinsWindowsUpdated(cs);
      // } else {
        onCoinSpinsWindowsUpdated([]);
      // }
       
    }, 250);
    return () => { clearTimeout(t); }
  }, [window]); // eslint-disable-line react-hooks/exhaustive-deps

  React.useEffect(() => {
    const reels = config.reelsSetup.length;
    const rows = config.reelsSetup[0];
    const w = generateWindowFromReelStrips({
      reels,
      rows,
      reelIndexes: props.scenario.reelIndexes,
      reelStrips: useVortexReels ? config.vortexReels : (props.index > 0 ? config.freeSpinsReels : config.baseSpinsReels),
    });
    setWindow(w);
  }, [props.scenario.reelIndexes, useVortexReels]); // eslint-disable-line react-hooks/exhaustive-deps
  
  return <div className={`spin ${props.index > 0 ? 'spin-freespins' : ''}`}>
    <div className='spin-index-num'>{props.index}</div>
    <div style={{ marginBottom: '10px' }}>
      <label>
        <input 
          type="checkbox" 
          checked={useVortexReels} 
          onChange={(e) => setUseVortexReels(e.target.checked)}
        />
        {' '}Use Vortex Reels
      </label>
      {useVortexReels && (
        <label style={{ marginLeft: '15px' }}>
          <input 
            type="checkbox" 
            checked={editVortexCoins} 
            onChange={(e) => setEditVortexCoins(e.target.checked)}
          />
          {' '}Edit Coin Placement
        </label>
      )}
      
      {useVortexReels && editVortexCoins && (
        <div style={{ marginTop: '10px', padding: '10px', backgroundColor: '#f0f0f0', borderRadius: '4px' }}>
          <div style={{ marginBottom: '8px' }}>
            <strong>Vortex Coin Placement:</strong> Click on cells below to add/remove coins
          </div>
          <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', alignItems: 'center' }}>
            <label>
              Coin Type:
              <select 
                value={selectedCoinType} 
                onChange={(e) => setSelectedCoinType(e.target.value as any)}
                style={{ marginLeft: '5px' }}
              >
                <option value="price">Price</option>
                <option value="mini">Mini</option>
                <option value="minor">Minor</option>
                <option value="major">Major</option>
              </select>
            </label>
            
            {selectedCoinType === 'price' && (
              <label>
                Multiplier:
                <input 
                  type="number" 
                  value={selectedMultiplier} 
                  onChange={(e) => setSelectedMultiplier(Number(e.target.value))}
                  style={{ marginLeft: '5px', width: '60px' }}
                  min="1"
                  step="1"
                />
              </label>
            )}
            
            <button 
              onClick={() => updateScenario({ vortexCoins: config.reelsSetup.map((size: number) => Array(size).fill(null)) })}
              style={{ padding: '4px 8px' }}
            >
              Clear All Coins
            </button>
          </div>
        </div>
      )}
    </div>
    <BigWin
      config={config}
      reelStrips={useVortexReels ? config.vortexReels : (props.index > 0 ? config.freeSpinsReels : config.baseSpinsReels)}
      rowsByReel={config.reelsSetup}
      reelIndexes={props.scenario.reelIndexes}
      mode={useVortexReels ? 'Vortex' : (props.index > 0 ? 'Free Spins' : 'Base')}
      showFreespins={props.index === 0 && !useVortexReels}
      onApply={reelIndexes => updateScenario({ reelIndexes })}
    />
    <div className={'reelContainer'} style={{ position: 'relative' }}>
      {useVortexReels && (
        <div style={{ 
          position: 'absolute', 
          top: 0, 
          left: 0, 
          width: '100%', 
          height: '100%', 
          display: 'flex',
          pointerEvents: 'none',
          zIndex: 10
        }}>
          {config.reelsSetup.map((rows: number, ri: number) => (
            <div key={`overlay-${ri}`} style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
              {Array.from({ length: rows }).map((_, ci) => (
                <div
                  key={`cell-${ri}-${ci}`}
                  onClick={() => toggleCoinAtPosition(ri, ci)}
                  style={{
                    flex: 1,
                    pointerEvents: editVortexCoins ? 'auto' : 'none',
                    cursor: editVortexCoins ? 'pointer' : 'default',
                    border: hasCoinAtPosition(ri, ci) ? '3px solid gold' : (editVortexCoins ? '1px solid rgba(0,0,0,0.1)' : 'none'),
                    backgroundColor: hasCoinAtPosition(ri, ci) ? 'rgba(255,215,0,0.3)' : 'transparent',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '24px',
                    fontWeight: 'bold',
                    color: 'gold',
                    textShadow: '0 0 4px black',
                  }}
                  title={editVortexCoins ? `Reel ${ri}, Row ${ci}` : ''}
                >
                  {hasCoinAtPosition(ri, ci) && '💰'}
                </div>
              ))}
            </div>
          ))}
        </div>
      )}
      {props.scenario.reelIndexes.map((ri, i) => <Reel 
        reelIndex={ri} 
        setReelIndex={ (props: {reelIndex: number, dir?: 1 | -1, forcedIndex?: number }) => setReelIndex(props) } 
        reelStrips={(useVortexReels ? config.vortexReels : (props.index > 0 ? config.freeSpinsReels : config.baseSpinsReels))[i]} 
        index={i} 
        rows={config.reelsSetup[i]} 
        key={`reel-${props.index}-${i}`}/>)}
    </div>

    <CoinSpins window={window} coinSpinsWindow={props.scenario?.otherData?.coinSpins || []} onCoinSpinsWindowsUpdated={onCoinSpinsWindowsUpdated} config={props.config} />
  
  </div>
}
export default Spin;
